import { Article, Create } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { VoyageFormField } from "./VoyageFormField";

export const VoyageAdditional = ({ dataState, setDataState }) => {
    const { t } = useTranslation();

    return (
        <>
            <M_Fieldset
                labelInside
                label={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "25px",
                            marginLeft: "10px",
                        }}
                    >
                        <Create
                            style={{ marginRight: "10px", scale: "1.3" }}
                        />{" "}
                        {t("AdditionalInfo")}
                    </div>
                }
                elements={
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                        }}
                    >
                        <VoyageFormField
                            label={t("AdditionalSValue")}
                            type={dataState.IsView ? "disabled" : "text"}
                            code="VoyageAdditionalSValue1"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("AdditionalNValue")}
                            type={dataState.IsView ? "disabled" : "number"}
                            code="VoyageAdditionalNValue1"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("AdditionalDValue")}
                            type={dataState.IsView ? "disabledDate" : "date"}
                            code="VoyageAdditionalDValue1"
                            data={dataState}
                            setData={setDataState}
                        />
                        <VoyageFormField
                            label={t("AdditionalDValue")}
                            type={dataState.IsView ? "disabledDate" : "date"}
                            code="VoyageAdditionalDValue2"
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>
                }
            />
        </>
    );
};
